import { combineReducers } from "redux";
import app from "./app";
import auth from "./auth";
import bp from "./bp";
import dialog from "./dialog";
import dict from "./dict";
import filters from "./filters";
import map from "./map";
export const combinedReducer = combineReducers({
    app,
    auth,
    bp,
    dialog,
    dict,
    filters,
    map,
});
